export const uk = {
    notifications: 'Оповещения'
};
